<template>
  <div>
    <div class="sayfahead">
      <h1>E-Posta</h1>
      <el-button-group class="YeniBtn">
        <router-link tag="button" class="el-button el-button--info el-button--small"
                     to="/iletisim/sms"> Mail Gönder
        </router-link>
        <el-button size="small" type="info">Mail Ayarları</el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
      </el-row>
    </div>
  </div>
</template>

<script>
    export default {
        name: "mail"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iletisim/mail.vue